import { HeadCell } from 'components/ui/EnhancedTable';
import useAxios from 'library/axios'; 
import { useState } from 'react';
import {IReport, IReportTable, IReportTableColumn ,IReportSearch } from "../models/Report";
import { useTranslation  } from 'react-i18next';
import { ITextFilterElement } from 'components/ui/BasicTextFilterForm';
import { useNavigate } from 'react-router-dom';

import { saveAs } from "file-saver";

const _ = () => {

    const axios = useAxios();     

    const createReport = async (report: IReport)  =>       
        await (await axios.post('/api/configuration/report/create', report)).data;       
        
    const updateReport = async (report: IReport)  =>       
        await (await axios.post('/api/configuration/report/update', report)).data; 
    
    const getReport = async (id  : number )  => {
      const {data} = (await axios.get(`/api/configuration/report/get-report/${id}`));
      return await data;
    }

    const getReports = async (criteria: IReportSearch) : Promise<IReport[]> => {
      const {name, description} = criteria;

      const {data} = (await axios.get(`/api/configuration/report/get-reports?name=${name}&description=${description}`));
      return await data;
    }

    const getReportsByEntity = async (entityName: string) : Promise<IReport[]> => {
      
      const {data} = (await axios.get(`/api/configuration/report/get-reports-by-entity?entityName=${entityName}`));
      return await data;
    }

    const getReportTablesByReport = async (reportId : number) : Promise<IReportTable[]>  => {
      
      const {data} = (await axios.get(`/api/configuration/report/get-reportTables-by-report?reportId=${reportId}`));
      return await data;
    }

    const getReportTableColumnsByReport = async (reportId : number) : Promise<IReportTableColumn[]>  => {
      
      const {data} = (await axios.get(`/api/configuration/report/get-reportTableColumns-by-report?reportId=${reportId}`));
      return await data;
    }

    const getReportTableColumnsByReportTable = async (reportTableId : number) : Promise<IReportTableColumn[]>  => {
      
      const {data} = (await axios.get(`/api/configuration/report/get-reportTableColumns-by-reportTable?reportTableId=${reportTableId}`));
      return await data;
    }

    const retriveReportDocumentFile = async (reportId : number, documentLanguage: string) : Promise<{fileToken: string, fileName: string}>  => {
      
      const {data} = (await axios.get(`/api/configuration/report/retrive-report-document-file?reportId=${reportId}&documentLanguage=${documentLanguage}`));
      return await data;
    }


    const downloadReportDocumentsZip = async (reportId: number, reportName: string) => {

    try {
      const response = await axios.get(`/api/configuration/report/retrive-report-document-zip?reportId=${reportId}&reportName=${reportName}`, {
        responseType: "arraybuffer", // VERY important
      });

      // Create a blob from the response
      const blob = new Blob([response.data], { type: "application/zip" });
      saveAs(blob, `Report_${reportName}.zip` )
    //   const url = window.URL.createObjectURL(blob);

    //   // Create a temporary download link
    //   const a = document.createElement("a");
    //   a.href = url;
    //   a.download = `Report_${reportId}.zip`;
    //   a.click();

    //   // Cleanup
    //   window.URL.revokeObjectURL(url);
     } catch (error) {
      console.error("Error downloading report ZIP:", error);
    }
  }

    return {    
      createReport,
      updateReport,

      getReport,
      getReports,
      getReportsByEntity,

      getReportTablesByReport,
      getReportTableColumnsByReport,
      getReportTableColumnsByReportTable,

      retriveReportDocumentFile,
      downloadReportDocumentsZip

      
    } 
}

export default _;


export const useBasicFilterReport = ( onRowDoubleClick: (event: React.MouseEvent<unknown>, row: IReport) => void  ) => {

  const { getReports } = _();

  const { t, i18n } = useTranslation();   
  const navigate = useNavigate();

  

  const [headReportCells, setHeadReportCells]  = useState<HeadCell<IReport>[]>([
    {id:'name', label : t('Name'),  display: true, type: 'string', },
    {id:'description', label : t('Description'),  display: true, type: 'string', },

  ]); 

  const [filterElements, ] = useState([       
        {name: 'name', text: t('Name'), value: ''}, 
        {name: 'description', text: t('Description'), value: ''},       
      ]);

  const [filteredReports, ] = useState<IReport[]>([]); 

  const onFilterButtonClick = async (filterElements: ITextFilterElement[]): Promise<IReport[]> => {
                
    const name = filterElements.find( elt => elt.name === 'name')?.value || '';
    const description = filterElements.find( elt => elt.name === 'description')?.value || '';
    
    const arr = await getReports( {name, description} );
    
    return arr;
  }

  const objKey: keyof IReport = 'id';

  return {
    title: t('Request data'), headCells: headReportCells, objKey,
    filterElements, rows: filteredReports, 
    onFilterButtonClick, onRowDoubleClick
  }
}

